import { useEffect, useState } from "react"
import { Syllabus } from "../../../../types/dataModel"
import useFetch from "../../../../hooks/useFetch"
import { API } from "../../../../common/Constants"
import PreLoader from "../../../../core/common/preLoader"
import { getAPIHeaders, isNotEmpty } from "../../../../common/Utils"
import FormFooter from "../../../../core/common/formFooter"

interface Props {
    syllabus: Syllabus
    onSuccess: ()=> void
    readonly?: boolean
}

const ModifySyllabus = ({syllabus, onSuccess, readonly}:Props) => {
    const [formData, setFormData] = useState<Syllabus | undefined>(syllabus)
    const [msgBox, setMsgBox] = useState<any>({
      msg: "",
      error: false
    });
    const {isLoading, error, data, status, callFetch } = useFetch();

    useEffect(()=>{
      setFormData(syllabus)
    },[syllabus])

    const reset = () => {
      resetMsgBox()
    }

    const resetMsgBox = () => {
      setMsgBox({
        msg: "",
        error: false
      })
    }

    useEffect(() => {
              if(data && status && status < 299){
                setMsgBox({msg: "Updated successfully", error: false})
                onSuccess()
              }
    }, [status, data]);
        
        
    useEffect(() => {
            if(error){
              if(error.response?.data){
                setMsgBox({msg: error.response?.data, error: true})
              } else{
                setMsgBox({msg: 'Something went wrong please try again later.', error: true})
              }
            }
    }, [error]);


    const handleSubmit = (event:any) => {
          event.preventDefault()
          if(!isNotEmpty(formData?.title)){
            setMsgBox({msg: "Please provide title", error: true})
          } else if(!isNotEmpty(formData?.code)){
            setMsgBox({msg: "Please provide code", error: true})
          } else {
            setMsgBox({msg:"",error: false})
            callFetch(API.SYLLABUS,
                  'PUT',
                  getAPIHeaders(),
                  null,
                  {
                     ...formData
                  }
              );
          }
    }

    const renderForm = () => {

      return (
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Modify Syllabus</h4>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={reset}
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <form>
            <div className="modal-body pb-0">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Title <span className="text-danger"> *</span></label>
                    <input type="text" className="form-control" 
                    disabled={readonly}
                    value={formData?.title}
                    onChange={(e)=>{
                      setFormData({
                        ...formData,
                        title: e.target.value
                      })
                    }}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <input type="text" className="form-control"
                        disabled={readonly}
                        value={formData?.description}
                        onChange={(e)=>{
                            setFormData({
                                ...formData,
                                description: e.target.value
                            })
                        }} />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Code <span className="text-danger"> *</span></label>
                    <input type="text" className="form-control"
                        value={formData?.code}
                        onChange={(e)=>{
                          setFormData({
                                ...formData,
                                code: e.target.value
                            })
                        }} disabled/>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <FormFooter
                readonly={readonly}
                onCancel={reset}
                onSave={handleSubmit}
                error={msgBox.error}
                message={msgBox.msg} 
              />
            </div>
          </form>
        </div>
      )
    }

    return (
      <div className="modal fade" id="edit_syllabus"
        data-bs-backdrop="static"
        data-bs-keyboard="false">
        <PreLoader showLoader={isLoading} />
        <div className="modal-dialog modal-dialog-centered modal-md"
          >
          {renderForm()}
        </div>
      </div>
    )
}

export default ModifySyllabus